/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".example-container[_ngcontent-%COMP%]{height:600px;overflow:auto}mat-table[_ngcontent-%COMP%]{width:100%}.caducado[_ngcontent-%COMP%]{color:red}.onTime[_ngcontent-%COMP%]{color:green}"];
export { styles as styles };
